module.exports = __webpack_public_path__ + "img/reportlist-icon.6b68f5ce.svg";